/**
 * RoleAssumptionBanner Component
 *
 * A persistent banner shown at the top of the screen when a Platform Admin
 * is viewing the application as a different role.
 */

import { useTranslation } from 'react-i18next';
import { useRoleAssumption, ROLE_LABELS } from '../../context/RoleAssumptionContext';
import './RoleAssumptionBanner.css';

export default function RoleAssumptionBanner() {
  const { t } = useTranslation();
  const { isAssuming, assumedRole, exitAssumedRole } = useRoleAssumption();

  // Don't render if not assuming a role
  if (!isAssuming || !assumedRole) {
    return null;
  }

  return (
    <div className="role-assumption-banner" role="alert">
      <div className="banner-content">
        <svg
          className="banner-icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <span className="banner-text">
          {t('roleAssumption.viewingAs')}{' '}
          <strong>{ROLE_LABELS[assumedRole.role]}</strong>.{' '}
          {t('roleAssumption.restricted')}
        </span>
        <button className="banner-exit-btn" onClick={exitAssumedRole}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          {t('roleAssumption.exitRoleView')}
        </button>
      </div>
    </div>
  );
}
